import styled from 'styled-components';
import { mediaMin } from '@spa/shared/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${({ theme }) => theme.gap(7)}
`;

export const Year = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 265px;

  ${mediaMin.mediumBreakpoint`
    width: 100%;
  `}
`;

export const YearTitle = styled.h2`
  font-size: ${props => props.theme.rem(18)};
  font-weight: 600;
  line-height: ${props => props.theme.rem(20)};
  color: ${props => props.theme.colors.blueDianne};
`;

export const Months = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 58px);
  grid-template-rows: repeat(3, 50px);
  gap: 10px;
  margin-top: ${props => props.theme.space(5)};

  ${mediaMin.mediumBreakpoint`
    width: 100%;
    grid-template-columns: repeat(4, 1fr);
  `}
`;

export const Month = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  border-radius: 4px;
  color: ${props => props.theme.colors.cornFlowerBlue};
  background-color: ${props => props.theme.colors.mistySilver};

  &.available {
    background: ${props => props.theme.colors.bluishCyan};

    & > span {
      color: ${props => props.theme.colors.blueDianne};
    }
  }

  &.occupied {
    background: ${props => props.theme.colors.palePeach};
  }

  & > .occupied ~ span {
    color: ${props => props.theme.colors.blueDianne};
  }

  span {
    &.quarters,
    &.three-quarters,
    &.halfs {
      position: absolute;
      height: 50px;
      background: ${props => props.theme.colors.bluishCyan};
      top: 0;
      left: 0;
      z-index: 1;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }

    &.three-quarters {
      width: 75%;
    }

    &.quarters {
      width: 25%;
    }

    &.halfs {
      width: 50%;
    }

    &.halfs-last,
    &.three-quarters-last,
    &.quarters-last {
      left: unset;
      right: 0;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }

    &.halfs,
    &.halfs-last,
    &.quarters-last,
    &.three-quarters-last {
      &.occupied {
        background: ${props => props.theme.colors.palePeach};
      }
    }
  }
`;

export const MonthTitle = styled.span`
  font-size: ${props => props.theme.rem(16)};
  line-height: ${props => props.theme.rem(24)};
  text-transform: capitalize;
  z-index: 1;
`;

export const MonthPrice = styled.span`
  font-size: ${props => props.theme.rem(14)};
  z-index: 1;
`;

export const Legend = styled.div`
  display: flex;
  ${({ theme }) => theme.gap(4)}
  flex-basis: 100%;
  margin-top: ${props => props.theme.space(7)};

  span {
    display: inline-flex;
    align-items: center;
    position: relative;
    padding-inline-start: ${props => props.theme.space(9)};
    color: ${props => props.theme.colors.blueDianne};

    &:before {
      content: '';
      position: absolute;
      left: 0;
      width: 20px;
      height: 20px;
      border-radius: 4px;
    }

    &:first-child {
      &:before {
        background: ${props => props.theme.colors.bluishCyan};
      }
    }

    &:last-child {
      &:before {
        background: ${props => props.theme.colors.palePeach};
      }
    }
  }
`;
